var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleCoinsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0H50V60H7C3.13401 61 0 56.866 0 53V7Z",
    fill: "#8E2274"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36.1953V38C14 39.5469 17.6953 40.75 22.25 40.75C26.8047 40.75 30.5 39.5469 30.5 38V36.1953C28.6953 37.4414 25.4727 38 22.25 38C18.9844 38 15.7617 37.4414 14 36.1953ZM27.75 24.25C32.3047 24.25 36 23.0469 36 21.5C36 19.9961 32.3047 18.75 27.75 18.75C23.1953 18.75 19.5 19.9961 19.5 21.5C19.5 23.0469 23.1953 24.25 27.75 24.25ZM14 31.6836V33.875C14 35.4219 17.6953 36.625 22.25 36.625C26.8047 36.625 30.5 35.4219 30.5 33.875V31.6836C28.6953 33.1445 25.4727 33.875 22.25 33.875C18.9844 33.875 15.7617 33.1445 14 31.6836ZM31.875 32.1562C34.3242 31.6836 36 30.7812 36 29.75V27.9453C34.9688 28.6328 33.5078 29.1055 31.875 29.4062V32.1562ZM22.25 25.625C17.6953 25.625 14 27.1719 14 29.0625C14 30.9961 17.6953 32.5 22.25 32.5C26.8047 32.5 30.5 30.9961 30.5 29.0625C30.5 27.1719 26.8047 25.625 22.25 25.625ZM31.6602 28.0742C34.2383 27.6016 36 26.6992 36 25.625V23.8203C34.4531 24.8945 31.832 25.4531 29.082 25.625C30.3281 26.2266 31.2734 27.043 31.6602 28.0742Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCoinsIcon);
export default __webpack_public_path__ + "static/media/purpleCoinsIcon.79555fcf.svg";
export { ForwardRef as ReactComponent };